import Reflux from "reflux";
import LottieActions from "../actions/LottieActions";

const LottieStore = Reflux.createStore({
  listenables: [LottieActions],
  storeName: "LottieStore",

  init() {
    this.state = {
      playingStates: new Map(),
      toggleRequestIds: new Map(),
      loadErrors: new Map(),
    };
  },

  onTogglePlayPause(elementId, layout) {
    const key = `${elementId}_${layout}`;
    const currentId = this.state.toggleRequestIds.get(key) || 0;
    this.state.toggleRequestIds.set(key, currentId + 1);
    this.trigger(this.state);
  },

  onSetPlayingState(elementId, layout, isPlaying) {
    const key = `${elementId}_${layout}`;
    this.state.playingStates.set(key, isPlaying);
    this.trigger(this.state);
  },

  onSetLoadError(elementId, layout, hasError) {
    const key = `${elementId}_${layout}`;
    this.state.loadErrors.set(key, hasError);
    this.trigger(this.state);
  },

  onCleanup(elementId, layout) {
    const key = `${elementId}_${layout}`;
    this.state.playingStates.delete(key);
    this.state.toggleRequestIds.delete(key);
    this.state.loadErrors.delete(key);
    this.trigger(this.state);
  },

  getState() {
    return this.state;
  },

  getToggleRequestId(elementId, layout) {
    const key = `${elementId}_${layout}`;
    return this.state.toggleRequestIds.get(key) || 0;
  },

  isPlaying(elementId, layout) {
    const key = `${elementId}_${layout}`;
    return this.state.playingStates.get(key) || false;
  },

  hasLoadError(elementId, layout) {
    const key = `${elementId}_${layout}`;
    return this.state.loadErrors.get(key) || false;
  },
});

export default LottieStore;
